import moment from 'moment';
import * as types from '../../constants/assertReports/actionType'
import Edit from '../../../asset/svg/EditIcon.svg';
import Delete from '../../../asset/svg/Delete.svg'
import { Tune } from '@material-ui/icons';

import { replaceNull } from "../../../../src/utils/commonFunction/CommanFunction";
const initialState = {
  vender: [],
  softwareCategory: [],
  software: [],
  user: [],
  isExportAllLoading:false,
  systemName: [],
  isLoadingFilter: true,
  venderTable: {
    head: [],
    body: []
  },
  isLoadingVenderTable: true,
  venderByApp: [],
  isLoadingVenderByApp: true,
  categoriesByApp: [],
  isLoadingCategoriesByApp: true,
  categorySoftware: {
    head: [],
    body: []
  },
  isLoadingCategorySoftware: true,
  allInformationGrid: {
    head: [],
    body: []
  },
  isLoadingAllInformationGrid: true,
  softwareCountByVender: [],
  isLoadingSoftwareCountByVender: true,
  deviceCountByVender: [],
  isLoadingDeviceCountByVender: false,
  exportTable: [],

  unMappedApplication: {
    head: [],
    body: []
  },
  unMappedApplicationExport: [],
  unMapIsLoading: true,
  mappedApplicationMsg: "",
  isMappedApplicationSuccess: false,

  skippedApplication: {
    head: [],
    body: []
  },
  skippedApplicationExport: [],
  skippedIsLoading: true,
  skippedApplicationMsg: "",
  skippedApplicationSuccess: false,

  isLoadingHWSummary: false,
  hardwareDetail: [],
  licenseStatistics: {
    head: [],
    body: []
  },
  isLicenseStatisticsLoading: false,

  biosTable: [{ head: [], body: [] }],
  isLoadingBiosTable: true,

  // GetUserWiseDashboardITAM STATE
  softwareApplicationList: [{ head: [], body: [] }],
  systemWiseApplicationCountList: [],
  systemWiseUsernameList: [],
  systemDetailList: [],
  isLoadingUserWiseDashboardITAM: false,
  systemNames: [],
  getSystemnameList: [],
  getUsernameList: [],
  isLoadingGetSystemUsernameList: false,
  selectedBios: "",
  antivirusList:[],
  driveList:[],
  scanSummary:[],
  ipDetails:[],
  pdfHtml:[],
  keyboardList:[],
  monitorList:[]
}
const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.FILTER:
      let softwareVendor = action.data.softwareVendor.filter((ele, ind) => ind === action.data.softwareVendor.findIndex(elem => elem.softwareVendorName === ele.softwareVendorName));
      let softwareCategory = action.data.softwareCategory.filter((ele, ind) => ind === action.data.softwareCategory.findIndex(elem => elem.softwareCategoryName === ele.softwareCategoryName));
      let swGenericNameFilter = action.data.softwareGeneric.filter((ele, ind) => ind === action.data.softwareGeneric.findIndex(elem => elem.softwareGenericName === ele.softwareGenericName));
      let swSystemName = action.data.systemInfo.filter((ele, ind) => ind === action.data.systemInfo.findIndex(elem => elem.systemname === ele.systemname));

      return {
        ...state,
        vender: action.data.softwareVendor,
        softwareCategory: action.data.softwareCategory,
        software: action.data.softwareGeneric,
        // user: action.data.FullName.map(i => {
        //     return { id: i.FullName, value: i.FullName, selected: false,userID:i.UserId }
        // }),
        systemName: swSystemName.map(i => {
          return { id: i.systemname, value: i.systemname, selected: false, userID: i.authorizedId }
        }),
      }
    case types.ASSET_DETAILS:
      let swGenericName = action.data.filter((ele, ind) => ind === action.data.findIndex(elem => elem.swVendor === ele.swVendor));
      var data = swGenericName.map((i, index) => {
        return [typeof i.swVendor != 'object' ? i.swVendor : "", "", "", {
          id: index,
          isExpendable: false, child: [action.data
            .filter(item => item.swVendor == i.swVendor)
            .map((value, index) => {
              return [value.swGenericName, value.AppCount, value.VersionCount]
            })]
        }]
      })
      return {
        ...state,
        venderTable: {
          head: [
            { label: "Vendor", align: "left" },
            { label: "App Count", align: "right" },
            { label: "Version Count", align: "right" },
          ],
          body: data
        },
        isLoadingVenderTable: false
      }
    case types.FAILED_ASSET_DETAILS:
      return {
        ...state,
        venderTable: {
          head: [],
          body: []
        },
        isLoadingVenderTable: false
      }

    case types.VENDER_BY_APP:
      return {
        ...state,
        venderByApp: action.data,
        isLoadingVenderByApp: false
      }
    case types.FAILED_VENDER_BY_APP:
      return {
        ...state,
        venderByApp: [],
        isLoadingVenderByApp: false
      }
    case types.CATEGORIES_BY_APP:
      return {
        ...state,
        categoriesByApp: action.data,
        isLoadingCategoriesByApp: false
      }
    case types.FAILED_CATEGORIES_BY_APP:
      return {
        ...state,
        categoriesByApp: [],
        isLoadingCategoriesByApp: false
      }
    case types.CATEGORY_SOFTWARE:

      let swGroup = action.data.filter((ele, ind) => ind === action.data.findIndex(elem => elem.swGroup === ele.swGroup));
      let genericName = action.data.filter((ele, ind) => ind === action.data.findIndex(elem => elem.swGenericName === ele.swGenericName));
      var data = swGroup.map((i, index) => {
        return [i.swGroup, "", "", {
          id: index,
          isExpendable: false, child: genericName
            .filter(item => item.swGroup == i.swGroup)
            .map((value, index) => {
              return [value.swGenericName, typeof value.Days == 'object' ? "" : value.Days, value.LastUsedDate ? moment(value.LastUsedDate).format("DD MMM") : '']
            })
        }]
      })
      return {
        ...state,
        categorySoftware: {
          head: [
            { label: "Category", align: "left" },
            { label: "Days", align: "center" },
            { label: "Last Used On", align: "left" },

          ],
          body: data
        },
        isLoadingCategorySoftware: false
      }
    case types.FAILED_CATEGORY_SOFTWARE:
      return {
        ...state,
        categorySoftware: [],
        isLoadingCategorySoftware: false
      }
    case types.ALL_INFORMATION_GRID:
      var data = action.data.map((i, index) => {
        return [typeof i.swVendor == 'object' ? "" : i.swVendor, typeof i.swGenericName == "object" ? "" : i.swGenericName, typeof i.swName == "object" ? "" : i.swName, typeof i.MajorVersion == "object" ? "" : i.MajorVersion, typeof i.FullName == "object" ? "" : i.FullName, typeof i.LastUsedDate == 'object' ? "" : i.LastUsedDate]
      })

      var application = action.data.map(i => {
        return { FullName: i.FullName, LastUsedDate: typeof i.LastUsedDate == 'object' ? "" : i.LastUsedDate, MajorVersion: i.MajorVersion, swGenericName: i.swGenericName, swName: i.swName, swVendor: i.swVendor }
      })
      return {
        ...state,
        allInformationGrid: {
          head: [
            { label: "Vendor", align: "left" },
            { label: "Software", align: "left" },
            { label: "Software SV", align: "left" },
            { label: "Version", align: "right" },
            { label: "User", align: "left" },
            { label: "Last Used On", align: "left" },
          ],
          body: data
        },
        exportTable: application,
        isLoadingAllInformationGrid: false
      }
    case types.FAILED_ALL_INFORMATION_GRID:
      return {
        ...state,
        allInformationGrid: [],
        isLoadingAllInformationGrid: false
      }
    case types.SOFTWARE_COUNT_BY_VENDOR:
      var data = action.data.slice(0, 20).map(i => {
        return { x: i.swVendor, y: i.AppCount }
      })
      return {
        ...state,
        softwareCountByVender: [{ data: data }],
        isLoadingSoftwareCountByVender: false
      }
    case types.FAILED_SOFTWARE_COUNT_BY_VENDOR:
      return {
        ...state,
        softwareCountByVender: [],
        isLoadingSoftwareCountByVender: false
      }
    case types.DEVICE_COUNT_BY_VENDER:
      var data = action.data.slice(0, 20).map(i => {
        return { x: i.swGenericName, y: i.DeviceCount }
      })

      return {
        ...state,
        deviceCountByVender: [{ data: data }],
        isLoadingDeviceCountByVender: false
      }
    case types.FAILED_DEVICE_COUNT_BY_VENDER:
      return {
        ...state,
        deviceCountByVender: [],
        isLoadingDeviceCountByVender: false
      }
    case types.SHOW_LOADER:
      return {
        ...state,
        isLoadingVenderTable: true,
        isLoadingVenderByApp: true,
        isLoadingCategoriesByApp: true,
        isLoadingCategorySoftware: true,
        isLoadingAllInformationGrid: true,
        isLoadingSoftwareCountByVender: true,
        isLoadingDeviceCountByVender: true,
        softwareCountByVender: [],
        deviceCountByVender: [],
      }


    case types.UNMAPPED_APPLICATION:
      
      var data = action.data.map((i, index) => {
        return [
          { id: index, name: i.name, Checkbox: true, isChecked: false },
          i.vendor, i.softwareVersion,
        ]
      })
      var unMap = action.data.map((i, index) => {
        return { "applicationName": i.name, "category": i.vendor, "type": i.softwareVersion }
      })
      return {
        ...state,
        unMappedApplication: {
          head: [{
            label: 'Application Name',
            align: 'left'
          },
          {
            label: 'Vendor Name',
            align: 'left'
          },
          {
            label: 'Software Version',
            align: 'right'
          }
          ],
          body: data
        },
        unMappedApplicationExport: unMap,
        unMapIsLoading: false
      }
    case types.FAILED_UNMAPPED_APPLICATION:
      return {
        ...state,
        unMappedApplication: {
          head: [{
            label: 'Application Name',
            align: 'left'
          },
          {
            label: 'Vendor Name',
            align: 'left'
          },
          {
            label: 'Software Version',
            align: 'right'
          }],
          body: []
        },
        unMappedApplicationExport: [],
        unMapIsLoading: false

      }
    case types.SUCCESS_MAPPED_APPLICATION:
      return {
        ...state,
        mappedApplicationMsg: action.data,
        isMappedApplicationSuccess: true
      }
    case types.FAILED_MAPPED_APPLICATION:
      return {
        ...state,
        mappedApplicationMsg: action.data,
        isMappedApplicationSuccess: false
      }
    case types.REMOVE_MAPPED_APPLICATION_MSG:
      return {
        ...state,
        mappedApplicationMsg: '',
        isMappedApplicationSuccess: false
      }


    case types.SKIPPED_APPLICATION:
      var data = action.data.map((i, index) => {
        return [
          i.name,
          { name: i.name, isDelete: true },
        ]
      })
      var Kipped = action.data.map((i, index) => {
        return { "applicationName": i.name, }
      })
      return {
        ...state,
        skippedApplication: {
          head: [
            { label: 'Application Name', align: 'left' },
            {
              label: "Action", align: "right"
            },
          ],
          body: data
        },
        skippedApplicationExport: Kipped,
        skippedIsLoading: false
      }

    case types.FAILED_SKIPPED_APPLICATION:
      return {
        ...state,
        skippedApplication: {
          head: [{
            label: 'Application Name',
            align: 'left'
          }
          ],
          body: data
        },
        skippedApplicationExport: [],
        skippedIsLoading: false

      }
    case types.DELETE_SKIPPED_APPLICATION:
      let filteredData = state.skippedApplication.body.filter(value => (value[0].name = action.appName));
      let changed = { ...state.skippedApplication.head, body: filteredData }
      return {
        ...state,
        skippedApplication: changed
      }
    case types.SUCCESS_DELETE_SKIPPED_APPLICATION_MSG:
      return {
        ...state,
        skippedApplicationMsg: action.data,
        skippedApplicationSuccess: true
      }
    case types.FAILED_DELETE_SKIPPED_APPLICATION_MSG:
      return {
        ...state,
        skippedApplicationMsg: action.data,
        skippedApplicationSuccess: false
      }
    case types.REMOVE_SKIPPED_APPLICATION_MSG:
      return {
        ...state,
        skippedApplicationMsg: "",
        skippedApplicationSuccess: false
      }
    case types.FAILED_DELETE_SKIPPED_APPLICATION:
      return state

    case types.SUCCESS_HARDWARE_SUMMARY:
      var hardwareDetail = action.data.map(i => {
        return { Username: i.username, Product: i.product, Device: i.device, OS: i.os, Manufacturer: i.manufacturer, Edition: i.edition, Software: i.software, Version: i.version, bios: i.bios, assetName: i.assetName }
      })
      return {
        ...state,
        isLoadingHWSummary: false,
        hardwareDetail: hardwareDetail,
      }
    case types.FETCH_HARDWARE_SUMMARY:
      return {
        ...state,
        isLoadingHWSummary: true,
        hardwareDetail: [],
      }
    case types.FAILED_HARDWARE_SUMMARY:
      return {
        ...state,
        isLoadingHWSummary: false,
        hardwareDetail: [],
      }
    case types.SUCCESS_LICENSE_STATISTICS:
      var licenseStatistic = []
      var checkDuplicate = []
      action.data.map((i, index) => {
        if (checkDuplicate.includes(i.product)) {
          licenseStatistic.push([{product:i.product,isProductShow:true}, i.edition, i.license, i.licenseInstalled, i.licenseUsed, i.licenseAvailable, i.difference, { value: i.complaint, isComplaint: true, index: index }])
        }
        else {
          licenseStatistic.push([{product:i.product,isProductShow:true}, i.edition, i.license, i.licenseInstalled, i.licenseUsed, i.licenseAvailable, i.difference, { value: i.complaint, isComplaint: true, index: index }])
        }

        checkDuplicate.push(i.product)
      })
      return {
        ...state,
        licenseStatistics: {
          head: [
            { label: 'Product', colspan: 1 },
            { label: 'Edition', colspan: 1 },
            { label: 'License Type', colspan: 1 },
            { label: 'License Installed', colspan: 1, tophead: "Usage/Installed Licenses" },
            { label: 'License Used' },
            { label: 'License Available', colspan: 1, tophead: "Entitled Licenses" },
            { label: 'Difference', colspan: 2, tophead: "Final License Status" },
            { label: 'Complaint', colspan: 2 },

          ],
          body: licenseStatistic
        },
        isLicenseStatisticsLoading: false
      }
    case types.FAILED_LICENSE_STATISTICS:
      return {
        ...state,
        licenseStatistics: {
          head: [],
          body: []
        },
        isLicenseStatisticsLoading: false
      }
    case types.FETCH_LICENSE_STATISTICS:
      return {
        ...state,
        isLicenseStatisticsLoading: true
      }
    case types.SUCCESS_SYSTEM_NAME:
      var data = action.data.map(i => {
        return [i.systemNames, i.userNames, i.bioSerialNumber]
      })
      var systemNames = action.data.map(i => {
        return { systemNames: i.systemNames, userNames: i.userNames, bioSerialNumber: i.bioSerialNumber, isSelected: false }
      })
      return {
        ...state,
        systemNames: systemNames,
        biosTable: {
          head: [
            { label: "System Name", align: "left" },
            { label: "User Name", align: "left" },
            // { label: "User Name", align: "left" },
          ],
          body: data
        },
        isLoadingBiosTable: false
      }
    case types.FAILED_SYSTEM_NAME:

      return {
        ...state,
        biosTable: {
          head: [],
          body: []
        },
        isLoadingBiosTable: false
      }
    case types.FETCH_SYSTEM_NAME:
      return {
        ...state,
        biosTable: {
          head: [],
          body: []
        },
        isLoadingBiosTable: true
      }
    // GetUserWiseDashboardITAM
    case types.FETCH_USER_WISE_DASHBOARD_ITAM:
      return {
        ...state,
        softwareApplicationList: [],
        systemWiseApplicationCountList: [],
        systemWiseUsernameList: [],
        systemDetailList: [],
        isLoadingUserWiseDashboardITAM: true,
      }
    case types.SUCCESS_USER_WISE_DASHBOARD_ITAM:
      var data = []
      action.data.softwareApplicationList.map(i => {
        data.push([i.swGroup, i.vendor, i.name, i.edition==""?"-":i.edition, i.version==""?"-":i.version,i.profile==""?"-":i.profile, i.installedDate==""?"-":i.installedDate, i.lastUsedDate==""?"-":i.lastUsedDate])
      })
     // console.log(data)
      return {
        ...state,
        softwareApplicationList: {
          head: [
            { label: 'Software Group', align: 'left' },
            { label: 'Vendor', align: 'left' },
            { label: 'Software Name', align: 'left' },
            { label: 'Edition', align: 'left' },
            { label: 'Version', align: 'left' },
            { label: 'Install Profile', align: 'left' },
            { label: 'Installed On', align: 'left' },
            { label: 'Last Used Date', align: 'left' },
          ],
          body: replaceNull(data,[]),
        },
        systemWiseUsernameList: action.data.systemWiseUsernameList,
        systemWiseApplicationCountList: action.data.systemWiseApplicationCountList,
        systemDetailList: action.data.systemDetailList,
        antivirusList:action.data.antiVirusList,
        driveList:action.data.driveList,
        scanSummary:action.data.scanSummaryList,
        ipDetails:action.data.ipDetailList,
        keyboardList:action.data?.keyboardList,
        monitorList:action.data?.monitorList,
        isLoadingUserWiseDashboardITAM: false,
        pdfHtml:action.data.html
      }
    case types.FAILED_USER_WISE_DASHBOARD_ITAM:
      return {
        ...state,
        softwareApplicationList: [],
        systemWiseApplicationCountList: [],
        systemWiseUsernameList: [],
        systemDetailList: [],
        isLoadingUserWiseDashboardITAM: false,
      }
    case types.FETCH_GET_SYSTEM_USER_NEMELIST:
      return {
        ...state,
        getSystemnameList: [],
        getUsernameList: [],
        isLoadingGetSystemUsernameList: true,
      }
    case types.SUCCESS_GET_SYSTEM_USER_NEMELIST:
      var data = action.data.list
      var systemName = []
      data.map(i => {
        systemName.push({
          name: i.systemNames,
          value: i.systemNames
        })
      })
      var userName = []
      data.map(i => {
        userName.push({
          name: i.userNames,
          value: i.userNames,
          systemName: i.systemNames
        })
      })
      return {
        ...state,
        getSystemnameList: systemName,
        getUsernameList: userName,
        isLoadingGetSystemUsernameList: false,
      }
    case types.FAILED_GET_SYSTEM_USER_NEMELIST:
      return {
        getSystemnameList: [],
        getUsernameList: [],
        isLoadingGetSystemUsernameList: false,
      }

    // case types.UPDATE_LICENSE_STATISTICS:
    //   var licenseStatistic = []
    //   var arr = []
    //   var checkDuplicate = []
    //   var licenseUpdateArr = action.data.split(",");
    //   state.licenseStatistics.body.map(i => {
    //     if (i[5].txtIndex == licenseUpdateArr[1] && licenseUpdateArr[0] != "") {
    //       if (parseInt(i[3]) - parseInt(licenseUpdateArr[0]) > 0) {

    //         licenseStatistic.push([i[0], i[1], i[2], i[3], i[4], { isTextBox: i[5].isTextBox, isDisabled: false, txtIndex: i[5].txtIndex }, parseInt(i[3]) - parseInt(licenseUpdateArr[0]), { value: "Complaint", isComplaint: true, index: i[7].index }])
    //       }
    //       else {
    //         licenseStatistic.push([i[0], i[1], i[2], i[3], i[4], { isTextBox: i[5].isTextBox, isDisabled: false, txtIndex: i[5].txtIndex }, parseInt(i[3]) - parseInt(licenseUpdateArr[0]), { value: "Non-Complaint", isComplaint: true, index: i[7].index }])
    //       }
    //     }
    //     else {
    //       licenseStatistic.push([i[0], i[1], i[2], i[3], i[4], { isTextBox: i[5].isTextBox, isDisabled: false, txtIndex: i[5].txtIndex }, i[6], { value: i[7].value, isComplaint: true, index: i[7].index }])
    //     }
    //   })
    //   return {
    //     ...state,
    //     licenseStatistics: {
    //       head: [
    //         { label: 'Product', colspan: 1 },
    //         { label: 'Edition', colspan: 1 },
    //         { label: 'License Type', colspan: 1 },
    //         { label: 'License Installed', colspan: 1, tophead: "Usage/Installed Licenses" },
    //         { label: 'License Used' },
    //         { label: 'License Available', colspan: 1, tophead: "Entitled Licenses" },
    //         { label: 'Difference', colspan: 2, tophead: "Final License Status" },
    //         { label: 'Complaint', colspan: 2 },

    //       ],
    //       body: licenseStatistic
    //     },
    //     isLicenseStatisticsLoading: false
    //   }
    case types.SELECTED_BIOS:
      return {
        ...state,
        selectedBios: action.data
      }
      case types.EXPORTALL_LOADING:
        return {
          ...state,
          isExportAllLoading: action.data
        }
    default:
      return state
  }
}
export default reducer
